// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/static/" + {"3619":"B2BOnboardingModal","3763":"TopNavbarUpsellInner","3773":"MainContainer","8894":"human-verification-modal"}[chunkId] + "." + {"3619":"e51985a1","3763":"95b4acb9","3773":"ba64b0b9","8894":"77105264"}[chunkId] + ".css";
};